import { render, staticRenderFns } from "./xy2.vue?vue&type=template&id=d3e40c06&scoped=true&"
import script from "./xy2.vue?vue&type=script&lang=js&"
export * from "./xy2.vue?vue&type=script&lang=js&"
import style0 from "./xy2.vue?vue&type=style&index=0&id=d3e40c06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e40c06",
  null
  
)

export default component.exports